var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 39,
    rx: 19.5,
    fill: "#95A5B7",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 12.2031C18.1688 12.2031 15 14.3406 15 17.8C15 20 16.2375 21.25 16.9875 21.25C17.2969 21.25 17.475 20.3875 17.475 20.1438C17.475 19.8531 16.7344 19.2344 16.7344 18.025C16.7344 15.5125 18.6469 13.7313 21.1219 13.7313C23.25 13.7313 24.825 14.9406 24.825 17.1625C24.825 18.8219 24.1594 21.9344 22.0031 21.9344C21.225 21.9344 20.5594 21.3719 20.5594 20.5656C20.5594 19.3844 21.3844 18.2406 21.3844 17.0219C21.3844 14.9531 18.45 15.3281 18.45 17.8281C18.45 18.3531 18.5156 18.9344 18.75 19.4125C18.3187 21.2687 17.4375 24.0344 17.4375 25.9469C17.4375 26.5375 17.5219 27.1188 17.5781 27.7094C17.6844 27.8281 17.6313 27.8156 17.7938 27.7563C19.3688 25.6 19.3125 25.1781 20.025 22.3562C20.4094 23.0875 21.4031 23.4812 22.1906 23.4812C25.5094 23.4812 27 20.2469 27 17.3313C27 14.2281 24.3187 12.2031 21.375 12.2031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.042255c6a377ca247075b45379319b99.svg";
export { ForwardRef as ReactComponent };